import { Children, Fragment } from 'react';

const visitMeta = (tree) => {
  let name = 'Unknown';
  let type = 'unknown';

  if (tree.type === Fragment) {
    name = 'Fragment';
    type = 'fragment';
  }
  else if (typeof tree.type === 'string') {
    name = tree.type;
    type = 'string';
  }
  else if (typeof tree.type === 'function') {
    name = tree.type.displayName || tree.type.name || 'Unknown';
    type = 'function';
  }

  return { name, type };
};


const freezeChildren = (children, level) => {
  if (typeof children === 'undefined') {
    return null;
  }
  if (Array.isArray(children)) {
    return Children.map(children, child => freezeChild(child, level));
  }
  return freezeChild(children, level);
};

const freezeComponent = (tree, level = 0) => {
  // const verbose = false;
  // let indent = '';
  // if (verbose) {
  //   for (let i = 0; i < level; i++) {
  //     indent += '  ';
  //   }
  // }

  const { name, type } = visitMeta(tree);
  const key = (typeof tree.key === 'string') ? tree.key : null;
  const { props } = tree;
  const children = freezeChildren(props.children, level + 1);

  // if (verbose) {
  //   console.log(`${indent}name=${name}, type=${type}, key=${key}`);
  // }

  const extendedProps = Object.assign(
    {},
    tree.props,
    children ? { children } : null,
    key ? { key } : null
  );

  return {
    type: name,
    props: extendedProps,
  };
};

const freezeChild = (child, level) => {
  if (child === null) {
    return null;
  }
  if (
    typeof child === 'boolean' ||
    typeof child === 'number' ||
    typeof child === 'string'
  ) {
    return child;
  }
  if (child.type) {
    return freezeComponent(child, level);
  }
  return null;
};

export const freeze = (tree) => freezeComponent(tree);



// WEBPACK FOOTER //
// ./scripts/modules/freeze.js